import {GetPerksClubLink} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {makeBFFApiUrl} from 'main/factories/http';
import {RemoteGetPerksClubLink} from 'data/usecases';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetPerksClubLink = (): GetPerksClubLink =>
	new RemoteGetPerksClubLink(
		makeBFFApiUrl(ExternalLinkPoint.perksClub),
		makeAuthorizeHttpClientDecorator(),
	);
